module.exports = __webpack_public_path__ + "static/media/art10.71665acc.jpg";